export default function PrivacyPolicy({
  companyName = "HighQ Consulting",
  effectiveDate = "October 26, 2025",
}) {
  const styles = {
    page: {
      fontFamily:
        "Inter, Roboto, -apple-system, BlinkMacSystemFont, 'Segoe UI', Helvetica, Arial, sans-serif",
      color: "#111827",
      lineHeight: 1.6,
      padding: "32px",
      maxWidth: "900px",
      margin: "32px auto",
      background: "#ffffff",
      borderRadius: "10px",
      boxShadow: "0 6px 18px rgba(15, 23, 42, 0.06)",
    },
    header: {
      borderBottom: "1px solid #e6e9ee",
      paddingBottom: "16px",
      marginBottom: "20px",
    },
    h1: {
      fontSize: "28px",
      margin: 0,
      color: "#0f172a",
    },
    meta: {
      fontSize: "13px",
      color: "#6b7280",
      marginTop: "6px",
    },
    section: {
      marginBottom: "18px",
    },
    h2: {
      fontSize: "18px",
      margin: "8px 0 8px",
      color: "#0b1220",
    },
    p: {
      margin: "8px 0",
      fontSize: "15px",
    },
    footer: {
      borderTop: "1px solid #e6e9ee",
      paddingTop: "12px",
      marginTop: "20px",
      fontSize: "13px",
      color: "#6b7280",
    },
  };

  return (
    <article style={styles.page} aria-labelledby="privacy-heading">
      <header style={styles.header}>
        <h1 id="privacy-heading" style={styles.h1}>
          {companyName} Privacy Policy
        </h1>
        <div style={styles.meta}>Effective date: {effectiveDate}</div>
      </header>

      <section style={styles.section}>
        <h2 style={styles.h2}>Introduction</h2>
        <p style={styles.p}>
          At {companyName}, we respect your privacy. This Privacy Policy
          explains that we do not collect, store, or share any personal
          information from users who visit our website.
        </p>
      </section>

      <section style={styles.section}>
        <h2 style={styles.h2}>Information We Collect</h2>
        <p style={styles.p}>
          We do not collect any personal data, analytics data, or tracking
          information from visitors. Our website is designed to provide
          information only, without collecting or processing any user data.
        </p>
      </section>

      <section style={styles.section}>
        <h2 style={styles.h2}>Cookies</h2>
        <p style={styles.p}>
          We do not use cookies or similar technologies for tracking or
          analytics purposes.
        </p>
      </section>

      <section style={styles.section}>
        <h2 style={styles.h2}>Third-Party Links</h2>
        <p style={styles.p}>
          Our website may contain links to third-party websites for your
          convenience. We are not responsible for the privacy practices or
          content of those websites. Please review their privacy policies
          separately.
        </p>
      </section>

      <section style={styles.section}>
        <h2 style={styles.h2}>Changes to This Policy</h2>
        <p style={styles.p}>
          We may update this Privacy Policy occasionally. Any changes will be
          posted on this page with an updated effective date.
        </p>
      </section>

      <section style={styles.section}>
        <h2 style={styles.h2}>Contact Us</h2>
        <p style={styles.p}>
          If you have any questions about this Privacy Policy, you can contact
          us through our website’s contact page.
        </p>
      </section>

      <footer style={styles.footer}>
        <div>This Privacy Policy was last updated on {effectiveDate}.</div>
      </footer>
    </article>
  );
}
